import React from "react";
import "./CloudHero.css";
import "../CloudCommon.css";

export default function CloudHero() {
  return (
    <div id="cloud-hero" className="cloudmainclass">
      <div className="left">
        <h1>Cloud Consulting Services to Accelerate Digital Transformation</h1>
        <p>
          We help businesses design, migrate, and optimize cloud environments
          with secure, scalable strategies that drive agility, innovation, and
          faster time-to-value across the enterprise.{" "}
        </p>
      </div>
    </div>
  );
}
